import React from 'react';
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import axiosInstance, { API_URL, optionsCity } from '../common/Constants';
import Select from 'react-select';

const styles = (theme) => ({
  traceListContainer: {
    padding: theme.spacing(7, 20, 10),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 10, 10),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 5, 7),
    },
  },
  tracePlace: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1),
    },
  },
  tracePlacePicRoot: {
    width: theme.spacing(18),
    height: theme.spacing(18),
    border: '1px solid #ebebeb',
    backgroundColor: '#fff',
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
  },
  tracePlacePic: {
    width: '100%',
    height: 'auto',
    WebkitTouchCallout: 'none',
  },
  tracePlacePicText: {
    width: theme.spacing(18),
    height: theme.spacing(18),
    backgroundColor: theme.palette.primary.point,
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(12),
      height: theme.spacing(12),
      fontSize: '1.2em',
    },
  },
  tracePlaceTitle: {
    fontWeight: 600,
    paddingTop: theme.spacing(2),
  },
  completedStamp: {
    position: 'absolute',
    bottom: theme.spacing(-1),
    left: theme.spacing(-2),
    width: '60%',
    height: '50%',
    WebkitTouchCallout: 'none',
  },
});

class TraceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      traceList: [],
      userInfo: null,
      refresh: false,
      originList: [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.userInfo !== nextProps.userInfo) {
      return { userInfo: nextProps.userInfo, refresh: true };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.userInfo) {
      if (this.state.refresh) {
        this.setState({ refresh: false });
        this.getUserData();
      }
    }
  }

  componentDidMount() {
    //this.getUserData();
  }

  getUserData() {
    let buff = [];

    let res = { data: this.props.userInfo };

    if (res.data.stamp) {
      this.setState({ stamp: res.data.stamp });
    } else {
      this.setState({ stamp: [] });
    }
    if (res.data.course) {
      this.setState({ course: res.data.course });
    } else {
      this.setState({ course: [] });
    }
    axiosInstance.get(`${API_URL}/course/list`, { headers: { Pragma: 'no-cache' } }).then((_res) => {
      buff = _res.data;
      buff.sort((a, b) => {
        if (b.name > a.name) return -1;
        else if (b.name < a.name) return 1;
        else return 0;
      });
      if (_res.data && res.data.course) {
        for (let i = 0; i < res.data.course.length; i++) {
          for (let j = 0; j < _res.data.length; j++) {
            if (res.data.course[i] === _res.data[j].id) {
              buff[j].isCompleted = true;
            }
          }
        }
      }

      this.setState({ traceList: buff, originList: buff });
    });
  }

  render() {
    const { classes } = this.props;

    const mapToList = (datalist) => {
      return datalist.map((data, idx) => {
        return (
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            key={idx}
            // style={
            // window.matchMedia('(min-width: 960px)').matches ? { maxWidth: '20%', flexBasis: '20%', width: '20%' } : {}
            /* window.matchMedia('(min-width: 600px)').matches
                ? { maxWidth: '33.33%', flexBasis: '33.33%', width: '33.33%' }
                : { maxWidth: '50%', flexBasis: '50%', width: '50%' } */
            // }
            className={classes.tracePlace}
          >
            <div
              style={{ textAlign: 'center', cursor: 'pointer' }}
              onClick={() => {
                this.props.handleState('courseId', data.id);
                this.props.handleState('traceState', 'detail');
              }}
            >
              <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                {/^\b(https:\/\/s3\..{1,})\b/gi.test(data.img) ? (
                  <Avatar
                    src={data.img}
                    // style={!data.isCompleted ? { opacity: '0.3' } : {}}
                    classes={{
                      root: classes.tracePlacePicRoot,
                      img: classes.tracePlacePic,
                    }}
                    alt={`trace${idx}`}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                ) : /^\b(uploads\/.{1,})\b/gi.test(data.img) ? (
                  <Avatar
                    src={`http://61.254.62.162:4002/${data.img}`}
                    // style={!data.isCompleted ? { opacity: '0.3' } : {}}
                    classes={{
                      root: classes.tracePlacePicRoot,
                      img: classes.tracePlacePic,
                    }}
                    alt={`trace${idx}`}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                ) : (
                  <Avatar className={classes.tracePlacePicText} style={{ wordBreak: 'keep-all' }}>
                    {data.name}
                  </Avatar>
                )}
                {data.isCompleted && (
                  <img
                    src={'images/mypage/completed_stamp@2x.png'}
                    className={classes.completedStamp}
                    alt="completed_stamp"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                )}
              </div>
              <Typography className={classes.tracePlaceTitle}>{data.name}</Typography>
            </div>
          </Grid>
        );
      });
    };

    return (
      <div className={classes.traceListContainer}>
        <Select
          placeholder={'지역을 선택해 주세요'}
          options={optionsCity}
          isClearable={true}
          onChange={(param1, param2) => {
            if (param1) {
              this.setState({ traceList: this.state.originList.filter((data) => data.region === param1.value) });
            } else {
              this.setState({ traceList: this.state.originList });
            }
          }}
        />
        <Grid container style={{ display: 'flex' }}>
          {this.state.traceList ? mapToList(this.state.traceList) : null}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(TraceList);
